// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./seventytwo/72cms-ui/src/less/cms.less
// module id = ./seventytwo/72cms-ui/src/less/cms.less
// module chunks = 0